import { createSelector } from '@reduxjs/toolkit';

import type { IBanner } from '../../types/banners';
import { getFilterLocation } from '../filters/getFilterLocation';
import { locationsHashSelector } from '../locations/locationsListSelector';

import { bannersHashSelector } from './bannersSelector';

export const bannersByRegionIdSelector = createSelector(
  locationsHashSelector,
  getFilterLocation,
  bannersHashSelector,
  (locationsHash, filterLocation, bannersHash) => {
    const bannerIds = locationsHash[filterLocation]?.bannerIds || [];

    return bannerIds.reduce((acc, id) => {
      const banner = bannersHash[id];

      if (banner) {
        acc.push(banner);
      }

      return acc;
    }, Array.of<IBanner>());
  },
);
